module.exports = __webpack_public_path__ + "static/media/role.75c7674f.svg";